import { EnterpriseLinkIconButton } from '@mews-commander/ui';
import { IconName } from '@optimus-web/core';
import { useGenerateContractContext } from '../context/GenerateContractProvider';

export const IconBackButton = () => {
    const { customerId, reservationId } = useGenerateContractContext();

    if (customerId != null) {
        return (
            <EnterpriseLinkIconButton
                to="Customer/$id/Contracting"
                params={{ id: customerId }}
                type="button"
                variant="ghost"
                icon={IconName.ArrowLeft}
            />
        );
    }

    if (reservationId != null) {
        return (
            <EnterpriseLinkIconButton
                to="Reservation/Detail/$reservationId/Contracts"
                params={{ reservationId }}
                type="button"
                variant="ghost"
                icon={IconName.ArrowLeft}
            />
        );
    }

    return null;
};
